<template>
  <div class="section-preload-container" v-show="preloadShow">
    <div class="crane" ref="crane"></div>
    <div class="progress" v-if="data.progress !== 100">进入中 {{ data.progress }}%</div>
    <div class="enter" @click="startTourist" v-else>开 始</div>
    <div class="cloud2"></div>
  </div>
</template>

<script>
import anime from "animejs";
import lottie from 'lottie-web';

export default {
  props: {
    isLoaded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {
        progress: 0,
        isStarted: false,
      },
      preloadShow: true,
      publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    })
  },
  watch: {
    isLoaded(newVal) {
      if (!newVal) return;
      this.handleLoadComplete();
    }
  },
  methods: {
    init() {
      this.animation = anime({
        targets: this.data,
        progress: 95,
        easing: "cubicBezier(.5, .05, .1, .3)",
        duration: 1500
      });


      lottie.loadAnimation({
        container: this.$refs.crane, // the dom element that will contain the animation
        renderer: 'canvas',
        autoplay: true,
        loop: true,
        path: `${this.publicPath}baihe.json` // the path to the animation json
      });
    },
    // 主体程序加载完成
    async handleLoadComplete() {
      await this.animation.finished;
      anime({
        targets: this.data,
        progress: 100,
        easing: "cubicBezier(.5, .05, .1, .3)",
        round: 1,
        duration: 500
      });
    },
    async startTourist() {
      anime({
        targets: '.section-preload-container',
        opacity: [1, 0],
        easing: 'linear',
        duration: 300,
        complete: () => {
          this.preloadShow = false;
          this.$emit('startTourist');
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.section-preload-container {
  z-index:  999;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(~@/assets/preload/bg.png) center center / 100% 100% no-repeat;
}
.crane {
  position: absolute;
  left: 50%;
  bottom: 30%;
  width: 140px;
  height: 90px;
  margin-left: -70px;
}
.progress {
  z-index: 999;
  position: absolute;
  left: 50%;
  bottom: calc(30% - 95px);
  transform: translateX(-50%);
  color: #BF956C;
  font-size: 13px;
  text-align: center;
}
.enter {
  z-index: 999;
  position: absolute;
  left: 50%;
  bottom: calc(30% - 95px);
  transform: translateX(-50%);
  padding: 6px 20px;
  background: #BF956C;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  line-height: 1.2;
  &:active {
    opacity: .7;
  }
}
.cloud2 {
  z-index: 0;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 150px;
  background: url(~@/assets/bottom_cloud.png) center center / 100% 100%
    no-repeat;
}
</style>
